export type StocksReference = {
  CODE_RETOUR: '0' | '1';
  VARIANTE: StockVariante | StockVariante[];
};

export type StockVariante = Record<
  | 'ETAT_STOCK'
  | 'ETAT_STOCK_ID'
  | 'PRIX'
  | 'PRIX_BARRE'
  | 'QUANTITE_STOCK'
  | 'REFREEL'
  | 'TAILLE',
  string
>;

export type StockValue = 'O' | 'N';

export type StockType = {
  sku: string;
  size: string;
  state: StockStatusType;
  stateLabel: string;
};

export type StockStatusType = 0 | 1;

export const STOCK_STATUS_NOT_AVAILABLE = 0;
export const STOCK_STATUS_AVAILABLE = 1;
